import React, { createContext, useContext } from 'react';
import { AncpClient } from '@bizfirst/ancp-core';

export interface AncpContextValue {
  client: AncpClient;
}

export const AncpContext = createContext<AncpContextValue | null>(null);

/**
 * Returns the AncpClient from the nearest AncpProvider.
 * Throws if called outside of an AncpProvider.
 */
export function useAncpClient(): AncpClient {
  const ctx = useContext(AncpContext);
  if (!ctx) {
    throw new Error(
      'useAncpClient must be used inside an <AncpProvider>. ' +
      'Wrap your component tree with <AncpProvider client={...}>.'
    );
  }
  return ctx.client;
}
